<script setup lang="ts">
import ApplicationScoreService from '@/core/conversations/application-score/application-score.service';

// Mirrors the v4 CopilotScoreBlurb rows (the list does not say which version is coming) so the
// resume does not move when the card lands; real chip labels make the pills wrap at the same widths.
const chipLabels = Object.keys(ApplicationScoreService.getChipsToDisplayDictionary());
// One line per summary bullet: v4 key points are one-liners and the scoring prompt targets three.
const summaryLineWidths = ['w-3/4', 'w-2/3', 'w-4/5'];
</script>

<template>
  <div
    class="rounded-xl rounded-br border border-tint-60 bg-tint-20 p-4 motion-safe:animate-pulse"
    data-test="score-card-placeholder"
    aria-hidden="true"
  >
    <div class="h-6 w-56 rounded-sm bg-tint-60" data-test-row="title" />

    <div class="ml-4 mt-3" data-test-row="summary">
      <div
        v-for="width in summaryLineWidths"
        :key="width"
        class="flex h-5 items-center"
        data-test-row="summary-line"
      >
        <div class="h-3 rounded bg-tint-60" :class="width" />
      </div>
    </div>

    <div class="mt-3 flex justify-between gap-2" data-test-row="chips">
      <div class="flex flex-wrap gap-2" data-test-row="chip-list">
        <span
          v-for="label in chipLabels"
          :key="label"
          class="flex items-center rounded-full bg-tint-60 px-2 py-1.5 text-xs font-bold"
          data-test-row="chip"
        >
          <span class="mr-1.5 h-4 w-4 rounded-full bg-tint-80" />
          <span class="invisible">{{ label }}</span>
        </span>
      </div>

      <div class="self-end">
        <div class="flex min-h-7 min-w-[128px] items-center" data-test-row="feedback">
          <div class="h-4 w-full rounded bg-tint-60" />
        </div>
      </div>
    </div>
  </div>
</template>
